import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { BetaService } from '../services/beta.service';

@Injectable({
  providedIn: 'root',
})
export class BetaGuard implements CanActivate {
  constructor(
    private betaService: BetaService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const routePath = route.routeConfig?.path || '';

    // Check if the route is a beta module (including nested routes like 'nova/saved-files' or 'nova/:id')
    // Extract the base route (e.g., 'nova' from 'nova/saved-files' or 'nova/:id')
    const baseRoute = routePath.split('/')[0];

    if (this.betaService.isBetaModule(baseRoute)) {
      // Check if user has access to beta modules
      if (!this.betaService.hasAccessToModule(baseRoute)) {
        // Redirect non-beta users to insights dashboard
        this.router.navigate(['/conversation-insights']);
        return false;
      }
    }

    return true;
  }
}

